export const DATASET_DELIVERY_TAG = 'datasetDelivery';
export const DATASET_DELIVERY_BASE_PATH = 'data-admin/data-delivery';

export enum VerificationStatusEnum {
  NOT_VERIFIED = 'not_verified',
  READY_TO_VERIFY = 'ready_to_verify',
  VERIFICATION_IN_PROGRESS = 'verification_in_progress',
  VERIFIED = 'verified',
  VERIFY_FAILED = 'verify_failed',
}

export enum DeliveryStatusEnum {
  NOT_DELIVERED = 'not_delivered',
  READY_TO_DELIVER = 'ready_to_deliver',
  DELIVERY_IN_PROGRESS = 'delivery_in_progress',
  DELIVERED = 'delivered',
  DELIVERY_FAILED = 'delivery_failed',
}
